import React  from 'react';
import {Outlet, Navigate} from "react-router-dom"

const PublicRouter = () => {
  const isSignedIn = false;
  return !isSignedIn ? <Outlet /> : <Navigate to='/' />;
};

export default PublicRouter;
